<div class="inline-flex" [pTooltip]="tooltip | i18next" tooltipPosition="top" *ngIf="visible">
  <p-button
    [styleClass]="spacing + ' ' + 'p-button-' + (type ?? '') + ' ' + styleClass"
    [icon]="icon"
    (onClick)="onClick.emit($event)"
    [disabled]="disabled"
    [loading]="loading"
    [label]="label"
  ></p-button>
</div>
